import { useEffect, useState } from "react";
import TelemetryService from "../../services/TelemetryService";

function CookieConsent() {

    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        TelemetryService.init("UA-7010366-11");
        setShowBanner(TelemetryService.getCookieStatus() === "unsettled");
    }, [])

    function handleClick(onClickEvent) {
        onClickEvent();
        setShowBanner(TelemetryService.getCookieStatus() === "unsettled");
    }

    return (
        showBanner && <div className="cookieConsentBanner">
            <h3>We use cookies</h3>
            <p>This site uses cookies to enhance site navigation and analyze site usage to improve your browsing experience. By clicking on “Accept”, you agree to our use of cookies and other tracking technologies.</p>

            <div className="cookieButtonWrapper">
                <button className="cookieButtonDecline" onClick={() => handleClick(() => TelemetryService.declineCookies())}>Decline</button>
                <button className="cookieButtonAccept" onClick={() => handleClick(() => TelemetryService.allowCookies())}>Accept</button>
            </div>
        </div>
    )
}

export default CookieConsent;